import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7abhryx1k8: FaireBrandEntity = {
  token: "b_7abhryx1k8",
  type: "brand",
  name: "Talking Out of Turn",
  avatarUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/bafdd4f0689a71541e16548c7dc5583c5b7d9448bf6928dbc894cefc12ac6904/1557377302.png",
  bannerUrl: "https://cdn.faire.com/fastly/8564c9ee13c1dd1299ba2d64e0a16bd7f64c4aebba30a49ed30f52399efac12c.png",
  logoUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/bafdd4f0689a71541e16548c7dc5583c5b7d9448bf6928dbc894cefc12ac6904/1557377302.png",
  heroImageUrl: "https://cdn.faire.com/fastly/8564c9ee13c1dd1299ba2d64e0a16bd7f64c4aebba30a49ed30f52399efac12c.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 696,
  isTopShop: true,
  isInsider: true,
  description: "TOOT was born from a desire to create work that would have more meaning day in and day out. Paired with our rare in-house manufacturing capabilities, we are makers at scale; our people, our hands, one-by-one, right here in the USA. As a group of artists, dreamers, and doers looking to fill that infamous void, the idea of our designs on our goods in our favorite stores is what led us here. We did it and we did it for us! We can't wait to share our collection of bags, accessories, stationery, humor, and hugs with you.",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:15:43.348Z",
    importedBy: "entity-db-cli"
  }
};
